// import React from 'react'
import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  Button,
  Offcanvas,
  Form,
  Container,
  NavDropdown,
  Modal,
} from "react-bootstrap";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

import "../style/admin.css";
import { RxHamburgerMenu } from "react-icons/rx";
import axios from "axios";
import { apibasePath } from "../config";
import "../style/admin.css";
import toast from "react-hot-toast";
import {
  createCustomerCall,
  DeleteCustomer,
  EditCustomer,
  GetExistCustomer,
} from "../APICalls";
import useMedia from "use-media";
import { CheckLg } from "react-bootstrap-icons";

const CreateCustomer = ({ pageType }) => {
  const [customerCode, setCustomerCode] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const isMobileScreen = useMedia({ maxWidth: 600 });

  const [isCustFetched, setIsCustFetched] = useState(false);

  const [showModal, setShowModal] = useState(false)

  const isEditForm = pageType === "edit";
  //create customer
  const createCustomer = async () => {
    try {
      console.log("CREATE CUSTOMER CALLED");

      const data = await createCustomerCall({
        customer_number: mobileNo,
        customer_name: customerName,
        customer_code: customerCode,
      });
      if (data.error) {
        toast.error("Customer Code Already Exists");
        return;
      }
      console.log(data);
      toast.success("Customer created successfully");
      setCustomerCode("");
      setCustomerName("");
      setMobileNo("");
    } catch (error) {
      console.error("Error creating customer:", error);
      toast.error("Failed to create customer");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!customerCode || !customerName || !mobileNo) {
      toast.error("Please fill all fields");
      return;
    }
    createCustomer();
  };

  const handleFetchExitCust = async () => {
    if (!customerCode || customerCode.trim().length < 1) {
      toast.error("Enter Proper Customer Code");
      return;
    }

    const data = await GetExistCustomer(customerCode);
    if (!data?.data?.id) {
      toast.error("Enter Proper Customer Code");
      return;
    }
    toast.success("Customer Fetched Succesfully");
    setCustomerName(data?.data?.customer_name);
    setMobileNo(data?.data?.customer_number);
    setIsCustFetched(true);
  };

  const clearFields =() => {
    setCustomerCode("");
    setCustomerName("");
    setMobileNo("");
    setIsCustFetched(false);
  }

  const handleEditCust = async (e) => {
    e.preventDefault();
    const data = await EditCustomer(customerCode, {
      customer_number: mobileNo,
      customer_name: customerName,
    });

    if (data?.message == "Customer updated successfully.") {
      toast.success("Customer Updated Succesfully");
      clearFields();
    } else {
      toast.error("Failed To Update Customer");
    }
  };



  return (
    <>
      {/* Main Content */}
      <main className="content  ">
        <div
          className="d-flex flex-column justify-content-center align-items-center header-section  "
          style={{ height: "400px" }}
        >
          <Form.Label>
            {" "}
            {isEditForm
              ? "Enter Customer Code to Fetch Details"
              : "Enter Customer Details"}{" "}
          </Form.Label>

          <div style={{ width: "25rem", padding: "20px", border: "none" }}>
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <Form.Group className="mb-3 login_page position-relative border">
                <Form.Control
                  style={{
                    backgroundColor: "#C5CACF",
                    width: "370px",
                    padding: isEditForm ? "12px" : "auto",
                  }}
                  type="text"
                  value={customerCode}
                  onChange={(e) => setCustomerCode(e.target.value)}
                  placeholder={`Customer code ${isEditForm ? "↵" : ""}`}
                  required
                  onKeyDown={(e) => {
                    console.log(e.code);
                    if (
                      (e.code === "Enter" || e.code === "NumpadEnter") &&
                      isEditForm
                    ) {
                      handleFetchExitCust();
                    }
                  }}
                  disabled={isCustFetched}
                />
                {isEditForm && !isCustFetched && (
                  <Button
                    className="position-absolute"
                    style={{
                      right: isMobileScreen ? 6 : -5,
                      top: 6,
                      background: "rgb(57, 109, 114)",
                    }}
                    onClick={handleFetchExitCust}
                  >
                    {" "}
                    Get{" "}
                  </Button>
                )}
              </Form.Group>

              {((isEditForm && isCustFetched) || pageType == "create") && (
                <>
                  <Form.Group className="mb-3 login_page">
                    <Form.Control
                      style={{
                        backgroundColor: "#C5CACF",
                        width: "370px",
                        fontSize: "17px",
                      }}
                      type="text"
                      value={customerName}
                      onChange={(e) => setCustomerName(e.target.value)}
                      placeholder="Customer name"
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3 login_page">
                    <Form.Control
                      style={{ backgroundColor: "#C5CACF", width: "370px" }}
                      type="Number"
                      value={mobileNo}
                      onChange={(e) => setMobileNo(e.target.value)}
                      placeholder="Mobile no"
                      required
                      onKeyDown={(e) => {
                        if (e.code === "Enter" && !isEditForm) {
                          handleSubmit(e);
                        }
                      }}
                    />
                  </Form.Group>
                </>
              )}

              <div className="text-center mt-4 d-flex justify-content-center gap-2">
                <Button
                  style={{
                    borderRadius: "15px",
                    color: "white",
                    backgroundColor: "#396D72",
                    border: "1px solid #628573",
                    fontFamily: "Roboto",
                    fontWeight: "600",
                    fontSize: "12px",
                  }}
                  className="pt-2 pb-2 ps-4 pe-4"
                  type="button"
                  onClick={isEditForm ? handleEditCust : handleSubmit}
                >
                  Save
                </Button>
                {isEditForm && isCustFetched && (
                  <Button
                    style={{
                      borderRadius: "15px",
                      color: "white",
                      // backgroundColor: "#396D72",
                      // border: "1px solid #628573",
                      fontFamily: "Roboto",
                      fontWeight: "600",
                      fontSize: "12px",
                    }}
                    className="pt-2 pb-2 ps-4 pe-4"
                    type="button"
                    onClick={ ()  => setShowModal(true)}
                    variant="danger"
                  >
                    Delete
                  </Button>
                )}
              </div>
                  <GetModal
                  customerCode={customerCode}
                  clearFields={clearFields}
                  show={showModal}
                  onHide={ () => setShowModal(false) }
                   />
            </Form>
          </div>
        </div>
      </main>
    </>
  );
};

export default CreateCustomer;

function GetModal({customerCode,clearFields, show, onHide}) {
  
  const handleDelUser = async () => {
    const data = await DeleteCustomer(customerCode);

    if (data.error) {
     toast.error("Failed to Delete Customer");
     return;
    }

    toast.success('Deleted Customer Successfully')
    clearFields();
    onHide()
 };
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{ border: "none" }} closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {" "}
          Are You Sure ?
        </Modal.Title>
      </Modal.Header>

      <Modal.Footer style={{ border: "none" }}>
        <Button variant="outline-danger" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDelUser}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
